import { animate, style, transition, trigger  } from '@angular/animations';
import { AfterContentInit, Component, NgZone, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHatCowboy, faTshirt, faMugSaucer, faBottleWater, faTag, faKey } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './loading.html',
  styleUrl: './loading.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate('800ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('800ms ease-in', style({ opacity: 0, transform: 'scale(1.2)' }))
      ])
    ])
  ]
})
export class Loading implements OnInit{
  currentIndex = 0;
  // icons = [
  //   faHatCowboy,   // cap
  //   faTshirt,      // t-shirt
  //   faBottleWater, // bottle
  //   faMugSaucer,   // mug
  //   faTag,         // tag (instead of chain)
  //   faKey          // key (instead of photo frame, placeholder)
  // ];

  icons = [
    "./loading/1.png",
    "./loading/2.png",
    "./loading/3.png",
    "./loading/4.png",
    "./loading/5.png",
  ]

  constructor(
    private ngZone: NgZone   
  ) {}

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.ngZone.run(() => {
          this.currentIndex = (this.currentIndex + 1) % this.icons.length;
        });
      }, 1000);
    });
  }
}
